export const mapPublicHolidayDto = (dto) => ({
    id: dto.id,
    date: dto.date,
    description: dto.description
});